import { render, staticRenderFns } from "./biddingAnnouncement01.vue?vue&type=template&id=e825a5f4&scoped=true&"
import script from "./biddingAnnouncement01.vue?vue&type=script&lang=js&"
export * from "./biddingAnnouncement01.vue?vue&type=script&lang=js&"
import style0 from "./biddingAnnouncement01.vue?vue&type=style&index=0&id=e825a5f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e825a5f4",
  null
  
)

export default component.exports